import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nav", "tab", "slider", "copy", "preview"]

  connect() {
    // Auto-activate the first visible tab on connect
    this.activateFirstTab()
    requestAnimationFrame(() => this.updateSlider())
    window.addEventListener("resize", this.boundResize = () => this.updateSlider())
  }

  disconnect() {
    window.removeEventListener("resize", this.boundResize)
  }

  switch(event) {
    const tabId = event.currentTarget.dataset.tabId

    // Update tab button styles
    this.tabTargets.forEach(tab => {
      if (tab.dataset.tabId === tabId) {
        tab.classList.remove("text-[#8B8FA3]")
        tab.classList.add("text-[#5660FB]")
      } else {
        tab.classList.remove("text-[#5660FB]")
        tab.classList.add("text-[#8B8FA3]")
      }
    })

    // Show/hide copy sections
    this.copyTargets.forEach(copy => {
      if (copy.dataset.tabId === tabId) {
        copy.classList.remove("hidden")
      } else {
        copy.classList.add("hidden")
      }
    })

    // Show/hide preview sections with scale-in animation
    this.previewTargets.forEach(preview => {
      if (preview.dataset.tabId === tabId) {
        preview.classList.remove("hidden")
        // Re-trigger animation
        preview.classList.remove("sales-scale-in")
        void preview.offsetWidth // force reflow
        preview.classList.add("sales-scale-in")
      } else {
        preview.classList.add("hidden")
      }
    })

    // Update slider position
    this.updateSlider(event.currentTarget)
  }

  activateFirstTab() {
    const firstTab = this.tabTargets[0]
    if (!firstTab) return

    const firstTabId = firstTab.dataset.tabId

    // Set first tab as active
    this.tabTargets.forEach(tab => {
      if (tab.dataset.tabId === firstTabId) {
        tab.classList.remove("text-[#8B8FA3]")
        tab.classList.add("text-[#5660FB]")
      } else {
        tab.classList.remove("text-[#5660FB]")
        tab.classList.add("text-[#8B8FA3]")
      }
    })

    // Show first tab content, hide others
    this.copyTargets.forEach(copy => {
      if (copy.dataset.tabId === firstTabId) {
        copy.classList.remove("hidden")
      } else {
        copy.classList.add("hidden")
      }
    })

    this.previewTargets.forEach(preview => {
      if (preview.dataset.tabId === firstTabId) {
        preview.classList.remove("hidden")
        preview.classList.add("sales-scale-in")
      } else {
        preview.classList.add("hidden")
      }
    })
  }

  updateSlider(activeTab = null) {
    if (!activeTab) {
      activeTab = this.tabTargets.find(tab => tab.classList.contains("text-[#5660FB]"))
    }
    if (!activeTab || !this.hasSliderTarget || !this.hasNavTarget) return

    const navRect = this.navTarget.getBoundingClientRect()
    const tabRect = activeTab.getBoundingClientRect()

    this.sliderTarget.style.left = `${tabRect.left - navRect.left}px`
    this.sliderTarget.style.width = `${tabRect.width}px`
  }
}
